export default (http) => {
    return {
        queryByPage (data){
            return http.json({
                url: '/knowledge/category/query',
                data
            })
        },
        /**
         * 保存信息
         * @param data
         * @returns {*}
         */
        save(data) {
            return http.json({
                url: '/knowledge/category/save',
                data
            })
        },
        /**
         * 获取详情
         * @param data
         * @return {*}
         */
        getInfo(data) {
            return http.json({
                url: `/knowledge/category/get?id=${data.id}`
            })
        },
        /**
         * 删除
         * @param data
         * @returns {*}
         */
        remove(data) {
            return http.json({
                url: `/knowledge/category/delete?id=${data[0].id}`,
                data
            })
        },        
        /**
         * 查询列表
         * @param data
         * @returns {*}
         */
        query(data) {
            return http.json({
                url: `/knowledge/category/list`,
                data
            })
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/http/api/knowledgeCate.js